// Weather s
import hot from './hot.gif';
import sunny from './sunny.gif';
import partly_cloudy from './partly_cloudy.gif';
import heavy_rain from './heavy_rain.gif';
import noweather from './noweather.gif';
import shower from './shower.gif';
import snow from './snow.gif';

// Weather Images
import windPNG from './wind.png';
import humidityPNG from './humidity.png';
import pressurePNG from './pressure.png';
import cloudinessPNG from './cloudiness.png';
// Gradient
import gradientSVG from './gradient.svg';

const images = {
  hot,
  sunny,
  partly_cloudy,
  noweather,
  shower,
  snow,
  heavy_rain,
  windPNG,
  humidityPNG,
  pressurePNG,
  cloudinessPNG,
  gradientSVG
};

export default images;




// WEBPACK FOOTER //
// ./src/components/weather/images/index.js